import { render, staticRenderFns } from "./UptimeCounter.vue?vue&type=template&id=8ec67212&"
import script from "./UptimeCounter.vue?vue&type=script&lang=js&"
export * from "./UptimeCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports